<template>
  <div class="media-player">
    <audio v-if="mediaType === 'audio'"
          
      ref="plyr"
      controls
    >
      <source
        :src="post.acf.audio_file.url"
        :type="post.acf.audio_file.mime_type"
      />
    </audio>
    <div
      v-if="mediaType === 'video' && mediaID"
      class="plyr__video-embed"
      ref="plyr"
    >
      <iframe
        v-if="(videoSource === 'vimeo' || videoSource === 'youtube') && mediaID"
        :src="getVideoURL(parseInt(mediaID))"
        allowfullscreen
        allowtransparency
        allow="autoplay"
      ></iframe>
    </div>
  </div>
</template>

<script>
import postMixin from '@/mixins/postMixin'
// import Plyr from 'plyr'
import _isNull from 'lodash/isNull'
import _isUndefined from 'lodash/isUndefined'

export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
    startTime: {
      type: [Number, String],
      required: true,
    },
    mediaID: {
      type: [Number, String, Boolean],
      required: false,
    },
    removePlayerOptions: {
      type: Array,
      required: false,
    },
  },

  mixins: [postMixin],

  data() {
    return {
      screenLock: null,
      updateInterval: null,
      percentageComplete: 0,
      player: null,
      time: 0,
      timer: null,
      timerSpeed: 1000,
      mediaDuration: undefined,
      saveTickCounter: 0,
    }
  },

  computed: {

    mediaType() {
      return this.post.session_type[0]
    },

    plyrOptions() {
      // Video-only controls that don't apply to audio
      const videoOnly = ['pip', 'fullscreen', 'captions']
      const baseControls = [
        'play-large',
        'play',
        'progress',
        'current-time',
        'mute',
        'volume',
        'settings',
        'airplay',
      ]
      const videoSettings = ['quality', 'speed']
      const audioSettings = ['speed']

      if (this.mediaType === 'audio') {
        return {
          autoplay: false,
          controls: baseControls,
          settings: audioSettings,
        }
      }
      return {
        autoplay: false,
        controls: [...baseControls, ...videoOnly],
        settings: videoSettings,
      }
    },

    videoSource() {
      return this.post.acf.video_host
    },

    currentTimeInteraction() {
      return {
        id: this.id,
        type: this.post.type,
      }
    },
  },

  methods: {
    processPlayerOptions() {
      const {removePlayerOptions} = this
      if (!_isUndefined(removePlayerOptions)) {
        removePlayerOptions.forEach( opt => {
          const optKey = Object.keys(this.plyrOptions.controls).find(key => this.plyrOptions.controls[key] === opt)
          delete this.plyrOptions.controls[optKey]
        })
      }
    },
    getVideoURL(val) {
      if (this.videoSource === 'vimeo') return `//player.vimeo.com/video/${val}?loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media"`
      if (this.videoSource === 'youtube') return `//www.youtube.com/embed/${val}?origin=https://plyr.io&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1`
      return val
    },
    saveCurrentTime() {
      // Guard against NaN when player.duration is not yet available (audio still loading)
      const duration = this.player.duration
      const currentTime = this.player.currentTime
      if (!duration || !isFinite(duration) || !currentTime || !isFinite(currentTime)) return

      this.percentageComplete = (currentTime / duration) * 100
      this.currentTimeInteraction['timestamp'] = currentTime

      if (this.time !== 0) {
        const rawTime = this.interactionTime + this.time
        const totalInteractionTime = this.mediaDuration
          ? Math.min(rawTime, this.mediaDuration * 1.5)
          : rawTime
        this.getPercentViewed(totalInteractionTime, this.mediaDuration)
        this.currentTimeInteraction['percentViewed'] = this.percentViewed
        this.$emit('percentageViewed', this.percentViewed)
      }

      if (this.percentageComplete > (this.currentInteraction.percentageComplete || 0)) {
        this.currentTimeInteraction['percentageComplete'] = this.percentageComplete
      }

      if (this.mediaType === 'video') this.currentTimeInteraction['mediaType'] = 'video'
      if (this.mediaType === 'audio') this.currentTimeInteraction['mediaType'] = 'audio'
      if (this.player.playing) {
        this.saveTickCounter++
        // Dispatch to API every 6th tick (30s at 5s intervals)
        // Local tracking still updates every 5s for responsive UI
        if (this.saveTickCounter % 6 === 0) {
          this.$store.dispatch('user/putInteraction', this.currentTimeInteraction)
        }
        this.$emit('currentTime', currentTime)
      }
      if ( this.percentViewed >= 90 && typeof this.currentInteraction.dateCompleted !== 'string' && this.time >= 10 ) {
        this.$emit('mediaComplete')
      }
    },
    saveCurrentTimeInteraction(bool = true) {
      if (
        this.player.currentTime > 0 &&
        this.player.currentTime !== this.startTime
      )
        this.saveCurrentTime()
      if (bool === false) {
        clearInterval(this.updateInterval)
        this.updateInterval = null
        // Force final save on unmount regardless of tick counter
        if (this.currentTimeInteraction && Object.keys(this.currentTimeInteraction).length > 0) {
          this.$store.dispatch('user/putInteraction', this.currentTimeInteraction)
        }
        return
      } else {
        if (this.updateInterval === null) {
          this.updateInterval = setInterval(this.saveCurrentTime, 5000)
        }
      }
    },
    playerJumpTo(secs) {
      this.player.currentTime = parseInt(secs)
      if (!_isNull(this.player)) this.player.on('timeupdate', () => {})
    },

    getDurationFromMedia() {
      if (_isUndefined(this.currentInteraction.mediaDuration) && !_isUndefined(this.player.duration)) {
        this.mediaDuration = this.player.duration
        this.currentTimeInteraction['mediaDuration'] = this.mediaDuration
        this.$store.dispatch('user/putInteraction', this.currentTimeInteraction)
      }

    },

    startTimer(bool = true) {
      if (bool === false) {
        
        if (this.time !== 0) {
          // runs when play has ended
          const rawTime = this.interactionTime + this.time
          const totalInteractionTime = this.mediaDuration
            ? Math.min(rawTime, this.mediaDuration * 1.5)
            : rawTime

          this.currentTimeInteraction['interactionTime'] = totalInteractionTime
          this.$store.dispatch('user/putInteraction', this.currentTimeInteraction)
        }

        clearInterval(this.timer)
        this.timer = null
        this.time = 0
        return
      } else if (bool == 'pause') {
        clearInterval(this.timer)
        this.timer = null
      } else {
        this.timer = setInterval(() => {
          ++this.time
          // console.log({tick: this.time})
        }, this.timerSpeed)
      }
    },

    autostart() {
      const { $route, post } = this
      if (navigator.userActivation.hasBeenActive && $route.query.autostart && $route.hash.includes(post.slug)) {
        this.player.play()
      }
    },

    isScreenLockSupported() {
      return ('wakeLock' in navigator)
    },

    async screenLockEngage() {
      if (this.isScreenLockSupported()){
        try {
          this.screenLock = await navigator.wakeLock.request('screen');
          // console.log(this.screenLock)
        } catch(err) {
          console.log(err.name, err.message)
        }
        return this.screenLock
      }
    },

    screenLockRelease() {
      if (typeof this.screenLock !== 'undefined' && this.screenLock != null) {
        this.screenLock.release().then(() => {
          this.screenLock = null
        })
      }
    },
  },

  watch: {
    startTime(newVal) {
      this.playerJumpTo(newVal)
      return newVal
    },
    mediaID(newID) {
      // Reset mediaDuration when switching tracks so getDurationFromMedia
      // recaptures it from the new player instance
      this.mediaDuration = undefined
      this.percentageComplete = 0
      return newID
    },
  },

  mounted() {
    const { getDurationFromMedia, processPlayerOptions, autostart } = this
    processPlayerOptions()
    // Plyr is being loaded manually via scripts_vendors_ in the enqueue to sidestep build error due to changes in repo
    this.player = new Plyr(this.$refs.plyr, this.plyrOptions)

    // @todo figure out alternative method for setting currentTime on video load
    this.player.on('ready', () => {
      this.player.volume = 1
      autostart()
    })

    this.player.once('playing', () => {
      getDurationFromMedia()
      this.playerJumpTo(this.startTime)
    })

    this.player.on('playing', () => {
      if (this.timer == null) this.startTimer()
      this.saveCurrentTimeInteraction()
      this.screenLockEngage()
    })

    this.player.on('ratechange', () => {
      if (this.player.playing) this.startTimer(false)
      this.timerSpeed = 1000 / this.player.speed
      if (this.player.playing) this.startTimer()
    })

    this.player.on('pause', () => {
      if (this.timer != null) this.startTimer(false)
      this.saveCurrentTimeInteraction(false)
      this.screenLockRelease()
    })

    this.player.on('ended', () => {
      if (this.timer != null) this.startTimer(false)
      this.saveCurrentTimeInteraction(false)
      if (this.percentViewed > 90) this.$emit('nextMedia')
      this.screenLockRelease()
    })

    // Store handler references for proper cleanup in beforeDestroy
    this._visibilityHandler = async () => {
      if (document.visibilityState === 'hidden') {
        if (this.timer != null) this.startTimer(false)
        if (this.player && this.player.playing) this.player.pause()
      }
    }
    document.addEventListener('visibilitychange', this._visibilityHandler)

    this._beforeUnloadHandler = e => {
      if (this.player && this.player.playing) {
        e.preventDefault()
        this.player.pause()
        e.returnValue = ''
      }
    }
    window.addEventListener('beforeunload', this._beforeUnloadHandler)
  },

  beforeDestroy() {
    if (this.player) {
      if (this.timer != null) this.startTimer(false)
      this.saveCurrentTimeInteraction(false)
      this.player.destroy()
    }
    this.player = null
    // Clean up global event listeners to prevent memory leaks
    document.removeEventListener("visibilitychange", this._visibilityHandler)
    window.removeEventListener("beforeunload", this._beforeUnloadHandler)
  },
}
</script>

<style>
/* fixes issue with progress bar not filling space */
.plyr__controls .plyr__progress__container {
  flex: 1;
  min-width: 0;
}

button.plyr__control--overlaid {
  background: var(--brandAccent);
}

.plyr--full-ui input[type='range'] {
  color: var(--brandAccent) !important;
}

.plyr__control.plyr__tab-focus,
.plyr__control:hover,
.plyr__control[aria-expanded='true'],
.plyr__menu__container
  .plyr__control[role='menuitemradio'][aria-checked='true']::before {
  background: var(--brandAccent) !important;
}

.plyr--full-ui input[type='range']::-webkit-slider-thumb {
  background: var(--brandAccent) !important;
}

.plyr--full-ui input[type='range']::-moz-range-thumb {
  background: var(--brandAccent) !important;
}

.plyr--full-ui input[type='range']::-ms-thumb {
  background: var(--brandAccent) !important;
}

.plyr__controls {
  padding: calc(var(--itemSpacing) / 2) var(--itemSpacing) !important;
}

.plyr__controls > .plyr__control:first-child {
  background-color: var(--brandAccent);
  svg {
    fill: #fff !important;
  }
}

/* .media-player {
  position: relative;
  width: 100%;
  padding: 56.279% 0 0 0;
  > div {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    iframe {
      width: 100%;
      height: 100%;
    }
  }
} */

/* .plyr__menu__container .plyr__control[role='menuitemradio']::after {
  background:#000;border:0;height:6px;left:12px;opacity:0;top:50%;-webkit-transform:translateY(-50%) scale(0);transform:translateY(-50%) scale(0);-webkit-transition:opacity .3s ease,-webkit-transform .3s ease;transition:opacity .3s ease,-webkit-transform .3s ease;transition:transform .3s ease,opacity .3s ease;transition:transform .3s ease,opacity .3s ease,-webkit-transform .3s ease;width:6px;} */
</style>